import { useQuery } from '@tanstack/react-query'
import { AxiosResponse } from 'axios'
import { axiosInstance } from '../helpers'
import { VendorCOI } from './useVendorCOIs'

const QUERY_KEY = ['myVendorCOIs']

export const useMyVendorCOIs = () => {
    const {
        data: myCOIs,
        isLoading: isLoadingMyCOIs,
        error: errorMyCOIs,
        refetch: refetchMyCOIs,
    } = useQuery<AxiosResponse<VendorCOI[]>, Error>({
        queryKey: QUERY_KEY,
        queryFn: () => axiosInstance.get('/company/my-cois/'),
        refetchOnMount: true,
        refetchOnWindowFocus: false,
    })

    return {
        myCOIs: myCOIs?.data || [],
        isLoadingMyCOIs,
        errorMyCOIs,
        refetchMyCOIs,
    }
}
